import React, { useRef, useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  Zoom,
} from "@mui/material";
import { Add, Close, Check } from "@mui/icons-material";
import { formatCodiceAgo } from "../utils/codiceAgo";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom timeout={2000} in={true} ref={ref} {...props} />;
});
const NewClientModal = (props) => {
  const savingRef = useRef(false);
  const [saving, setSaving] = useState(false);
  const [open, setOpen] = useState(false);
  const [cliente, setCliente] = useState();
  const [validation, setValidation] = useState();

  const handleClickOpen = () => {
    setCliente({
      RagioneSociale: "",
      SedeIndirizzo: "",
      SedeLocalita: "",
      SedeCAP: "",
      CodiceAgo: "",
    });
    setValidation({
      RagioneSociale: false,
      SedeIndirizzo: false,
      SedeLocalita: false,
      SedeCAP: false,
    });
    setOpen(true);
  };

  const handleClose = () => {
    if (!savingRef.current) setOpen(false);
  };

  const handleChange = (e) => {
    if (savingRef.current) return;
    let c = { ...cliente };
    c[e.target.name] = e.target.value;
    setCliente(c);
  };

  const handleSave = async () => {
    if (savingRef.current) return;
    var check = false;
    let val = { ...validation };
    if (cliente.RagioneSociale === "" || cliente.RagioneSociale === null) {
      val.RagioneSociale = true;
      check = true;
    } else {
      val.RagioneSociale = false;
    }
    if (cliente.SedeIndirizzo === "" || cliente.SedeIndirizzo === null) {
      val.SedeIndirizzo = true;
      check = true;
    } else {
      val.SedeIndirizzo = false;
    }
    if (cliente.SedeLocalita === "" || cliente.SedeLocalita === null) {
      val.SedeLocalita = true;
      check = true;
    } else {
      val.SedeLocalita = false;
    }

    if (cliente.SedeCAP === "" || cliente.SedeCAP === null) {
      val.SedeCAP = true;
      check = true;
    } else {
      val.SedeCAP = false;
    }

    setValidation(val);

    if (!check) {
      savingRef.current = true;
      setSaving(true);
      try {
        const saved = await props.myFunction({ ...cliente });
        if (saved) setOpen(false);
      } finally {
        savingRef.current = false;
        setSaving(false);
      }
    }
  };

  return (
    <>
      <Button
        startIcon={<Add />}
        onClick={handleClickOpen}
        className="ButtonMiller"
      >
        Aggiungi
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="md"
        TransitionComponent={Transition}
      >
        <DialogTitle>Inserisci nuovo cliente</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                error={validation?.RagioneSociale}
                margin="dense"
                name="RagioneSociale"
                label="Ragione Sociale"
                type="text"
                fullWidth
                value={cliente?.RagioneSociale}
                onChange={handleChange}
                variant="outlined"
                helperText={
                  validation?.RagioneSociale ? "Campo obbligatorio" : ""
                }
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                error={validation?.SedeIndirizzo}
                margin="dense"
                name="SedeIndirizzo"
                label="Indirizzo"
                type="text"
                fullWidth
                value={cliente?.SedeIndirizzo}
                onChange={handleChange}
                variant="outlined"
                helperText={
                  validation?.SedeIndirizzo ? "Campo obbligatorio" : ""
                }
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                error={validation?.SedeLocalita}
                margin="dense"
                name="SedeLocalita"
                label="Località"
                type="text"
                fullWidth
                value={cliente?.SedeLocalita}
                onChange={handleChange}
                variant="outlined"
                helperText={
                  validation?.SedeLocalita ? "Campo obbligatorio" : ""
                }
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                error={validation?.SedeCAP}
                margin="dense"
                name="SedeCAP"
                label="Cap"
                type="text"
                fullWidth
                value={cliente?.SedeCAP}
                onChange={handleChange}
                variant="outlined"
                helperText={validation?.SedeCAP ? "Campo obbligatorio" : ""}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                margin="dense"
                fullWidth
                label="Codice Ago"
                name="CodiceAgo"
                type="text"
                inputProps={{ maxLength: 16 }}
                onBlur={(e) => {
                  const codiceAgo = formatCodiceAgo(e.target.value);
                  setCliente((previous) => ({
                    ...previous,
                    CodiceAgo: codiceAgo,
                  }));
                }}
                value={cliente?.CodiceAgo || ""}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            px: 3,
          }}
        >
          <Button
            variant="contained"
            className="ButtonMiller"
            startIcon={<Close />}
            disabled={saving}
            onClick={handleClose}
          >
            Annulla
          </Button>
          <Button
            variant="contained"
            className="ButtonMiller"
            startIcon={<Check />}
            disabled={saving}
            onClick={handleSave}
          >
            {saving ? "Creazione…" : "Crea"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default NewClientModal;
